import type { RouteExistsGuard } from '@backmarket/nuxt-layer-base/plugins/routeExists'

export const routeHasValidParams: RouteExistsGuard = (to) => {
  const params = Object.values(to.params)

  for (const param of params) {
    if (param === 'null' || param === 'undefined') {
      return { message: 'Invalid route param', status: 404 }
    }
  }

  return true
}
